import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFile = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsx("path", {
		d: "M22.5 21.753C22.5 22.1508 22.342 22.5323 22.0607 22.8137C21.7794 23.095 21.3978 23.253 21 23.253H3C2.60218 23.253 2.22064 23.095 1.93934 22.8137C1.65804 22.5323 1.5 22.1508 1.5 21.753V2.25299C1.5 1.85517 1.65804 1.47364 1.93934 1.19233C2.22064 0.911026 2.60218 0.752991 3 0.752991H18C18.3917 0.753036 18.7678 0.906288 19.048 1.17999L22.048 4.06199C22.1912 4.20181 22.3049 4.36886 22.3825 4.55331C22.4602 4.73776 22.5001 4.93587 22.5 5.13599V21.753Z",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		fill: "none"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6 9.00299L9.75 12.753L6 16.503",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		fill: "none"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.75 12.753H18",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		fill: "none"
	}));
});
export default SvgFile;
